import { useState, useCallback } from 'react';
import { Status } from 'hooks/requests/fetchUtils';
import useFetchApi from 'hooks/useFetchApi';
import useIovation from 'hooks/useIovation';
import useQueryParameters from 'hooks/useQueryParameters';
import { selectInstantCredit } from 'state/instantCredit';
import { useSelector } from 'react-redux';

const PATH = '/api/text_to_recover';

type TextToRecoverHook = () => [() => Promise<void>, Status, boolean];

export class TextToRecoverError extends Error {}

export const useTextToRecover: TextToRecoverHook = () => {
  const [error, setError] = useState<boolean>(false);
  const [status, fetch] = useFetchApi();

  const iovationBlackbox = useIovation();

  const {
    cardType: qpCardType,
    overrideKey,
    mockTTR: mockResponse,
    location,
    channel,
    subchannel,
    applicationSubType,
  } = useQueryParameters();

  const { logo, cardType: icCardType } = useSelector(selectInstantCredit);

  const sendTextToRecover = useCallback(async (): Promise<void> => {
    setError(false);

    const blackbox = await iovationBlackbox;
    const response = await fetch(PATH, {
      method: 'POST',
      body: {
        iovationBlackbox: blackbox,
        cardType: icCardType || qpCardType,
        overrideKey,
        logo: logo,
        location,
        channel,
        subchannel,
        applicationSubType,
        mockResponse,
      },
    });

    if (!response.ok) {
      setError(true);
      return Promise.reject(new TextToRecoverError());
    }
  }, [
    iovationBlackbox,
    fetch,
    icCardType,
    qpCardType,
    overrideKey,
    logo,
    location,
    channel,
    subchannel,
    applicationSubType,
    mockResponse,
  ]);

  return [sendTextToRecover, status, error];
};

export default useTextToRecover;
